import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { LocationModel } from '../../ngrx-store/app.state'
import { ppaPlace } from '../../utils/ppa.util'

/** A listed PPA the backend found like the one being added (its 409 SIMILAR_PPAS `suggestions`). */
export interface SimilarPpa {
  id: number
  slug_id: string
  name: string
  type_of_ppa: string
  corper_count: number
  review_count: number
  Locations?: LocationModel[]
  /** The same words - the same PPA, so it can't be added again. */
  same: boolean
}

export interface SimilarPpasDialogData {
  /** The name they typed. */
  name: string
  suggestions: SimilarPpa[]
}

/** `pick`: theirs is that one. `addNew`: it's none of them - add theirs. Closed without either: they'll look again. */
export type SimilarPpasDialogResult = { pick: SimilarPpa } | { addNew: true } | undefined

/**
 * "Is your PPA one of these?" - when the backend finds PPAs like the one a corp member is adding
 * (the profile's PPA field, the add-a-place form). Saying no adds theirs; it can't when one of
 * them has the same name.
 */
@Component({
  selector: 'app-similar-ppas-dialog',
  templateUrl: './similar-ppas-dialog.component.html',
  styleUrls: ['./similar-ppas-dialog.component.css'],
})
export class SimilarPpasDialogComponent {
  readonly ppaPlace = ppaPlace
  readonly canAddNew: boolean

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SimilarPpasDialogData,
    private dialogRef: MatDialogRef<SimilarPpasDialogComponent, SimilarPpasDialogResult>,
  ) {
    this.canAddNew = !data.suggestions.some((ppa) => ppa.same)
  }

  pick(ppa: SimilarPpa): void {
    this.dialogRef.close({ pick: ppa })
  }

  addNew(): void {
    this.dialogRef.close({ addNew: true })
  }
}
